import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import { useAuth } from '@sine/auth-client';
import { Loader, Modal, NavBar } from '@sine/sine-ui-components';
import UICVersion from '@sine/sine-ui-components/version';

import apiVersionService from '../../external/apiVersion/apiVersion.service';
import PageContainer from '../PageContainer';

export default function ApplicationFrame({ children }: PropsWithChildren) {
  const { authState } = useAuth();
  const [showVersionModal, setShowVersionModal] = useState(false);

  const versions = [
    {
      name: 'core-api',
      value: apiVersionService.getApiVersion('core'),
    },
    {
      name: 'web-check-in-api',
      value: apiVersionService.getApiVersion('web-check-in'),
    },
    {
      name: 'web-check-in-client',
      value: window.env.REACT_APP_CLIENT_VERSION,
    },
    {
      name: 'sine-ui-components',
      value: UICVersion,
    },
  ];

  return (
    <>
      <NavBar productBrand='core' onProductBrandClick={() => setShowVersionModal(true)} />

      <PageContainer>
        {children}
        <Loader show={authState === 'loading'} fillAndCenter />
      </PageContainer>

      {showVersionModal && (
        <Modal header='Version info' onClose={() => setShowVersionModal(false)} size='sm' show>
          {versions.map(({ name, value }) => (
            <div key={name}>
              {name}: {value}
            </div>
          ))}
        </Modal>
      )}
    </>
  );
}
